import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckPin = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.16667 0.918945H15.8333C16.75 0.918945 17.5 1.66895 17.5 2.58561V13.3606C17.5 13.9356 17.2083 14.4439 16.7667 14.7439L10.4667 18.9439C10.1833 19.1273 9.825 19.1273 9.54167 18.9439L3.23333 14.7439C2.79167 14.4439 2.5 13.9356 2.5 13.3606L2.50833 2.58561C2.50833 1.66895 3.25 0.918945 4.16667 0.918945ZM8.925 12.8273L15.25 6.50228C15.575 6.17728 15.5667 5.65228 15.2417 5.32728C14.9167 5.00228 14.3917 5.00228 14.0667 5.32728L8.33333 11.0606L5.93333 8.66061C5.60833 8.33561 5.08333 8.33561 4.75833 8.66061C4.43333 8.98561 4.43333 9.51061 4.75833 9.83561L7.75 12.8273C8.075 13.1523 8.6 13.1523 8.925 12.8273Z",
		fill: "currentColor"
	})
});
export default SvgCheckPin;
